(() => {
  const money = (cents, format) => {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, format);
    }
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 2
    }).format(cents / 100);
  };

  class LukzerProductDetail extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.variants = JSON.parse(this.querySelector('[data-product-variants]')?.textContent || '[]');
      this.media = JSON.parse(this.querySelector('[data-product-media]')?.textContent || '[]');
      this.form = this.querySelector('[data-lkz-product-form]');
      this.variantInput = this.querySelector('[data-variant-id]');
      this.addButton = this.querySelector('[data-add-to-cart]');
      this.addLabel = this.querySelector('[data-add-label]');
      this.message = this.querySelector('[data-form-message]');
      this.quantity = this.querySelector('[data-quantity]');
      this.thumbnailRail = this.querySelector('[data-thumbnails]');
      this.lightboxIndex = 0;
      this.lightboxTrigger = null;
      this.lightboxTouchStart = 0;
      this.thumbnailDrag = { active: false, pointerId: null, startX: 0, scrollLeft: 0, moved: false };

      this.bindEvents();
      this.restoreVariantFromUrl(false);
      this.ensureInitialHistoryState();
      this.attachReviewAnchor();
    }

    bindEvents() {
      this.querySelectorAll('input[data-option-value]').forEach((input) => {
        input.addEventListener('change', () => this.onOptionChange());
      });

      this.querySelectorAll('[data-colour-swatch]').forEach((button) => {
        button.addEventListener('click', () => this.selectColourSwatch(button));
      });

      this.addEventListener('click', (event) => this.onThumbnailClick(event), { capture: true });
this.addEventListener('mouseover', (event) => this.onThumbnailHover(event), { capture: true });
this.addEventListener('click', (event) => this.onThumbnailClick(event), { capture: true });



      this.querySelector('[data-thumb-prev]')?.addEventListener('click', (event) => this.onThumbnailArrow(event, -1));
      this.querySelector('[data-thumb-next]')?.addEventListener('click', (event) => this.onThumbnailArrow(event, 1));
      this.querySelector('[data-quantity-minus]')?.addEventListener('click', () => this.changeQuantity(-1));
      this.querySelector('[data-quantity-plus]')?.addEventListener('click', () => this.changeQuantity(1));
      this.querySelector('[data-mobile-add]')?.addEventListener('click', () => this.addButton?.click());
      this.querySelector('[data-mobile-buy]')?.addEventListener('click', () => this.triggerBuyNow());
      this.querySelector('[data-share]')?.addEventListener('click', () => this.shareProduct());
      this.bindThumbnailScroller();

      this.querySelectorAll('[data-open-lightbox]').forEach((button) => {
        button.addEventListener('click', (event) => this.openLightbox(event));
      });

      this.querySelector('[data-lightbox-close]')?.addEventListener('click', () => this.closeLightbox());
      this.querySelector('[data-lightbox-prev]')?.addEventListener('click', () => this.moveLightbox(-1));
      this.querySelector('[data-lightbox-next]')?.addEventListener('click', () => this.moveLightbox(1));
      this.querySelector('[data-lightbox]')?.addEventListener('click', (event) => {
        if (event.target === event.currentTarget) this.closeLightbox();
      });
      this.querySelector('[data-lightbox]')?.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.closeLightbox();
      });
      this.querySelector('[data-lightbox-media]')?.addEventListener('touchstart', (event) => {
        this.lightboxTouchStart = event.changedTouches[0]?.clientX || 0;
      }, { passive: true });
      this.querySelector('[data-lightbox-media]')?.addEventListener('touchend', (event) => {
        const distance = (event.changedTouches[0]?.clientX || 0) - this.lightboxTouchStart;
        if (Math.abs(distance) > 50) this.moveLightbox(distance > 0 ? -1 : 1);
      }, { passive: true });
      this.addEventListener('keydown', (event) => {
        if (!this.querySelector('[data-lightbox]')?.open) return;
        if (event.key === 'ArrowLeft') this.moveLightbox(-1);
        if (event.key === 'ArrowRight') this.moveLightbox(1);
      });

      this.querySelectorAll('[data-assembly-choice]').forEach((button) => {
        button.addEventListener('click', () => this.setAssembly(button.dataset.assemblyChoice));
      });

      this.querySelectorAll('.lkz-pdp__accordion > button').forEach((button) => {
        button.addEventListener('click', () => this.toggleAccordion(button));
      });

      this.querySelector('[data-delivery-form]')?.addEventListener('submit', (event) => this.checkDelivery(event));
      this.form?.addEventListener('submit', (event) => this.addToCart(event), true);
      this.querySelector('[data-review-link]')?.addEventListener('click', (event) => this.scrollToReviews(event));
      window.addEventListener('popstate', () => this.restoreVariantFromUrl(false));
    }

    onThumbnailClick(event) {
  const thumbnail = event.target.closest('[data-thumbnail]');
  if (!thumbnail || !this.contains(thumbnail)) return;

  if (this.thumbnailDrag.moved) {
    this.thumbnailDrag.moved = false;
    return;
  }

  event.preventDefault();

  const mediaId = thumbnail.dataset.mediaId;
  if (!mediaId) return;

  this.selectMedia(mediaId, true, thumbnail);
}

onThumbnailHover(event) {
  const thumbnail = event.target.closest('[data-thumbnail]');
  if (!thumbnail || !this.contains(thumbnail)) return;

  // Ignore hover while dragging the thumbnail rail
  if (this.thumbnailDrag.active || this.thumbnailDrag.moved) return;

  const mediaId = thumbnail.dataset.mediaId;
  if (!mediaId) return;

  // Don't repeatedly trigger for elements inside the same thumbnail
  const related = event.relatedTarget;
  if (related && thumbnail.contains(related)) return;

  this.selectMedia(mediaId, false, thumbnail);
}

    onThumbnailArrow(event, direction) {
      event.preventDefault();
      event.stopPropagation();
      this.selectAdjacentThumbnail(direction);
    }

    selectedOptions() {
      return [...this.querySelectorAll('[data-option-index]')].map((fieldset) => {
        return fieldset.querySelector('input[data-option-value]:checked')?.value;
      });
    }

    onOptionChange() {
      const selected = this.selectedOptions();
      const variant = this.variants.find((item) => item.options.every((option, index) => option === selected[index]));

      this.querySelectorAll('[data-option-index]').forEach((fieldset) => {
        const index = Number(fieldset.dataset.optionIndex);
        const checked = fieldset.querySelector('input[data-option-value]:checked');
        const label = this.querySelector(`[data-option-label="${index}"]`);
        if (label && checked) label.textContent = checked.value;
      });

      this.updateOptionAvailability(selected);
      this.updateVariant(variant, true);
    }

    selectColourSwatch(button) {
      if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;

      const variantId = Number(button.dataset.variantId);
      const variant = this.variants.find((item) => item.id === variantId);
      if (!variant?.available) {
        this.showMessage('This colour is currently sold out.', true);
        return;
      }

      variant.options.forEach((value, index) => {
        const input = [...this.querySelectorAll(`[data-option-index="${index}"] input[data-option-value]`)]
          .find((item) => item.value === value);
        if (input) input.checked = true;
        const label = this.querySelector(`[data-option-label="${index}"]`);
        if (label) label.textContent = value;
      });

      this.updateOptionAvailability(variant.options);
      this.updateVariant(variant, true);
    }

    updateOptionAvailability(selected) {
      this.querySelectorAll('[data-option-index]').forEach((fieldset) => {
        if (fieldset.classList.contains('lkz-pdp__option--colour')) return;
        const optionIndex = Number(fieldset.dataset.optionIndex);
        fieldset.querySelectorAll('input[data-option-value]').forEach((input) => {
          const possible = [...selected];
          possible[optionIndex] = input.value;
          const exists = this.variants.some((variant) => {
            return variant.available && variant.options.every((value, index) => {
              return index === optionIndex || !possible[index] || value === possible[index];
            });
          });
          input.nextElementSibling?.classList.toggle('is-unavailable', !exists);
          input.setAttribute('aria-disabled', String(!exists));
        });
      });
    }

    updateVariant(variant, updateUrl) {
      this.currentVariant = variant;
      const available = Boolean(variant?.available);
      const addText = available ? this.dataset.addToCartLabel || 'Add to Cart' : this.dataset.soldOutLabel || 'Sold Out';

      if (this.variantInput) this.variantInput.value = variant?.id || '';
      if (this.addButton) {
        this.addButton.disabled = !available;
        this.addButton.classList.toggle('lukzer-add-to-cart', available);
      }
      if (this.addLabel) this.addLabel.textContent = addText;

      const mobileButton = this.querySelector('[data-mobile-add]');
      if (mobileButton) {
        mobileButton.disabled = !available;
        mobileButton.classList.toggle('lukzer-add-to-cart', available);
        mobileButton.textContent = addText;
      }
      const mobileBuyButton = this.querySelector('[data-mobile-buy]');
      if (mobileBuyButton) mobileBuyButton.disabled = !available;

      this.querySelector('[data-dynamic-checkout]')?.classList.toggle('is-disabled', !available);
      this.updatePrice(variant);
      this.updateSku(variant);
      this.updateStockStatus(variant);
      this.updateColourSwatches(variant);
      this.clearMessage();

      const mediaId = variant?.featured_media?.id || this.dataset.defaultMediaId;
      if (mediaId) this.selectMedia(String(mediaId), false);

      if (updateUrl && variant) {
        const url = new URL(this.dataset.productUrl, window.location.origin);
        url.searchParams.set('variant', variant.id);
        window.history.pushState({ variantId: variant.id }, '', url);
      }

      if (this.variantInput) {
        this.variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      this.updateWishlistVariant(variant);
    }

    updatePrice(variant) {
      const price = this.querySelector('[data-price]');
      const compare = this.querySelector('[data-compare-price]');
      const discount = this.querySelector('[data-discount]');
      const mobilePrice = this.querySelector('[data-mobile-price]');
      if (!variant) return;

      const formatted = money(variant.price, this.dataset.moneyFormat);
      if (price) price.textContent = formatted;
      if (mobilePrice) mobilePrice.textContent = formatted;

      const hasDiscount = variant.compare_at_price > variant.price;
      compare?.classList.toggle('is-hidden', !hasDiscount);
      discount?.classList.toggle('is-hidden', !hasDiscount);
      if (hasDiscount) {
        compare.textContent = money(variant.compare_at_price, this.dataset.moneyFormat);
        discount.textContent = `${Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price)}% OFF`;
      }
    }

    updateSku(variant) {
      const sku = this.querySelector('[data-variant-sku]');
      if (sku) sku.textContent = variant?.sku || 'Not available';
    }

    updateStockStatus(variant) {
      const status = this.querySelector('[data-stock-status]');
      if (!status) return;
      status.textContent = variant?.available ? 'In stock' : 'Sold out';
      status.classList.toggle('is-sold-out', !variant?.available);
    }

    updateColourSwatches(variant) {
      if (!variant) return;
      this.querySelectorAll('[data-colour-swatch]').forEach((button) => {
        const optionIndex = Number(button.dataset.optionIndex);
        const active = variant.options[optionIndex] === button.dataset.optionValue;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
        if (active) {
          button.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        }
      });
    }

    restoreVariantFromUrl(updateUrl) {
      const id = Number(new URL(window.location.href).searchParams.get('variant'));
      const variant = this.variants.find((item) => item.id === id) || this.variants.find((item) => String(item.id) === this.variantInput?.value);
      if (!variant) return;

      variant.options.forEach((value, index) => {
        const input = [...this.querySelectorAll(`[data-option-index="${index}"] input[data-option-value]`)]
          .find((item) => item.value === value);
        if (input) input.checked = true;
        const label = this.querySelector(`[data-option-label="${index}"]`);
        if (label) label.textContent = value;
      });
      this.updateVariant(variant, updateUrl);
      this.updateOptionAvailability(variant.options);
    }

    ensureInitialHistoryState() {
      if (!this.currentVariant || new URL(window.location.href).searchParams.has('variant')) return;
      const url = new URL(this.dataset.productUrl, window.location.origin);
      url.searchParams.set('variant', this.currentVariant.id);
      window.history.replaceState({ variantId: this.currentVariant.id }, '', url);
    }

    mediaId(value) {
      const text = String(value || '');
      const numeric = text.match(/\d+$/);
      return numeric ? numeric[0] : text;
    }

    mediaMatches(element, id) {
      return this.mediaId(element?.dataset?.mediaId) === this.mediaId(id);
    }

    cssEscape(value) {
      if (window.CSS?.escape) return CSS.escape(String(value));
      return String(value).replace(/["\\]/g, '\\$&');
    }

    selectMedia(id, focus = false, sourceThumbnail = null) {
  const normalizedId = this.mediaId(id);

  // First try exact media ID
  let target = this.querySelector(
    `.lkz-pdp__media[data-media-id="${this.cssEscape(String(id))}"]`
  );

  // Then try normalized media ID
  if (!target) {
    target = [...this.querySelectorAll('.lkz-pdp__media')]
      .find((media) => this.mediaMatches(media, normalizedId));
  }

  if (!target) return;

  // Show selected main image
  this.querySelectorAll('.lkz-pdp__media').forEach((media) => {
    const active = media === target;

    media.classList.toggle('is-active', active);
    media.setAttribute('aria-hidden', String(!active));

    if (active) {
      media.hidden = false;
    } else {
      media.querySelectorAll('video').forEach((video) => video.pause());

      media.hidden = true;
    }
  });

  // Update actual main image
  this.syncActiveImage(target, normalizedId, sourceThumbnail);

  // Update thumbnails
  this.querySelectorAll('[data-thumbnail]').forEach((thumb) => {
    const active = this.mediaMatches(thumb, normalizedId);

    thumb.classList.toggle('is-active', active);
    thumb.classList.toggle('active', active);

    thumb.setAttribute('aria-current', active ? 'true' : 'false');

    if (active && focus) {
      thumb.scrollIntoView({
        behavior: this.prefersReducedMotion() ? 'auto' : 'smooth',
        block: 'nearest',
        inline: 'nearest'
      });

      thumb.focus?.({ preventScroll: true });
    }
  });

  this.dispatchEvent(
    new CustomEvent('lukzer:media-changed', {
      bubbles: true,
      detail: { mediaId: normalizedId }
    })
  );
}

    syncActiveImage(target, id, sourceThumbnail = null) {
      const image = target.querySelector('img.lkz-pdp__main-image');
      if (!image) return;

      const data = this.media.find((item) => this.mediaId(item.id) === this.mediaId(id));
      if ((!data || data.type !== 'image') && !sourceThumbnail) return;

      const displaySrc = sourceThumbnail?.dataset.fullImage || data?.displaySrc;
      const srcset = sourceThumbnail?.dataset.srcset || data?.srcset;
      const zoom = sourceThumbnail?.dataset.zoom || data?.zoom;
      const alt = sourceThumbnail?.dataset.alt || data?.alt || this.dataset.productTitle || '';

      if (displaySrc && image.getAttribute('src') !== displaySrc) {
        image.setAttribute('src', displaySrc);
        image.setAttribute('data-src', displaySrc);
      }
      if (srcset) {
        image.setAttribute('srcset', srcset);
        image.setAttribute('data-srcset', srcset);
      }
      image.setAttribute('alt', alt);

      const zoomTarget = target.querySelector('[data-zoom], [data-open-lightbox]');
      if (zoomTarget && zoom) {
        zoomTarget.setAttribute('data-zoom', zoom);
        zoomTarget.setAttribute('data-pswp-src', zoom);
        if (zoomTarget.matches('a')) zoomTarget.setAttribute('href', zoom);
      }
    }

    scrollThumbnails(direction) {
      const thumbs = this.thumbnailRail || this.querySelector('[data-thumbnails]');
      if (!thumbs) return;

      thumbs.scrollBy({
        left: direction * thumbs.clientWidth * 0.8,
        behavior: this.prefersReducedMotion() ? 'auto' : 'smooth'
      });
    }

    selectAdjacentThumbnail(direction) {
      const thumbnails = [...this.querySelectorAll('[data-thumbnail]')];
      if (!thumbnails.length) return;

      const activeIndex = Math.max(0, thumbnails.findIndex((thumb) => (
        thumb.classList.contains('is-active') || thumb.getAttribute('aria-current') === 'true'
      )));
      const nextThumb = thumbnails[(activeIndex + direction + thumbnails.length) % thumbnails.length];
      this.selectMedia(nextThumb.dataset.mediaId, true, nextThumb);
      this.scrollThumbnails(direction);
    }

    bindThumbnailScroller() {
      const thumbs = this.thumbnailRail;
      if (!thumbs || thumbs.dataset.lkzScrollerBound === 'true') return;
      thumbs.dataset.lkzScrollerBound = 'true';

      thumbs.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        this.thumbnailDrag = {
          active: true,
          pointerId: event.pointerId,
          startX: event.clientX,
          scrollLeft: thumbs.scrollLeft,
          moved: false
        };
        thumbs.setPointerCapture?.(event.pointerId);
      });

      thumbs.addEventListener('pointermove', (event) => {
        if (!this.thumbnailDrag.active || this.thumbnailDrag.pointerId !== event.pointerId) return;
        const delta = event.clientX - this.thumbnailDrag.startX;
        if (Math.abs(delta) > 10) this.thumbnailDrag.moved = true;
        thumbs.scrollLeft = this.thumbnailDrag.scrollLeft - delta;
      });

      const endDrag = (event) => {
        if (this.thumbnailDrag.pointerId === event.pointerId) {
          thumbs.releasePointerCapture?.(event.pointerId);
          window.setTimeout(() => {
            this.thumbnailDrag = { active: false, pointerId: null, startX: 0, scrollLeft: thumbs.scrollLeft, moved: false };
          }, 0);
        }
      };

      thumbs.addEventListener('pointerup', endDrag);
      thumbs.addEventListener('pointercancel', endDrag);
      thumbs.addEventListener('lostpointercapture', () => {
        window.setTimeout(() => {
          this.thumbnailDrag = { active: false, pointerId: null, startX: 0, scrollLeft: thumbs.scrollLeft, moved: false };
        }, 0);
      });
    }

    prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    changeQuantity(delta) {
      if (!this.quantity) return;
      this.quantity.value = Math.max(1, Number(this.quantity.value || 1) + delta);
      this.quantity.dispatchEvent(new Event('change', { bubbles: true }));
    }

    setAssembly(choice) {
      this.querySelectorAll('[data-assembly-choice]').forEach((button) => {
        const active = button.dataset.assemblyChoice === choice;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-checked', String(active));
      });
      const property = this.querySelector('[data-assembly-property]');
      if (property) property.value = choice;
    }

    toggleAccordion(button) {
      const panel = this.querySelector(`#${this.cssEscape(button.getAttribute('aria-controls'))}`);
      const expanded = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!expanded));
      const icon = button.querySelector('span');
      if (icon) icon.textContent = expanded ? '+' : '−';
      button.closest('.lkz-pdp__accordion')?.classList.toggle('is-open', !expanded);
      if (!panel) return;

      if (expanded) {
        panel.classList.remove('is-open');
        window.setTimeout(() => {
          if (button.getAttribute('aria-expanded') === 'false') panel.hidden = true;
        }, this.prefersReducedMotion() ? 0 : 180);
      } else {
        panel.hidden = false;
        window.requestAnimationFrame(() => panel.classList.add('is-open'));
      }
    }

    async shareProduct() {
      const url = new URL(this.dataset.productUrl, window.location.origin);
      if (this.currentVariant?.id) url.searchParams.set('variant', this.currentVariant.id);
      const title = this.dataset.productTitle || document.title;
      const data = { title, text: title, url: url.toString() };
      try {
        if (navigator.share) await navigator.share(data);
        else {
          await navigator.clipboard.writeText(data.url);
          this.showToast('Product link copied', false);
        }
      } catch (error) {
        if (error.name !== 'AbortError') this.showToast('Unable to copy the product link', true);
      }
    }

    openLightbox(event) {
      const activeId = this.querySelector('.lkz-pdp__media.is-active')?.dataset.mediaId;
      const foundIndex = this.media.findIndex((item) => String(item.id) === activeId);
      this.lightboxIndex = foundIndex >= 0 ? foundIndex : 0;
      this.lightboxTrigger = event?.currentTarget || this.querySelector('.product-gallery-action--zoom');
      if (!this.media.length) return;
      this.renderLightbox();
      const dialog = this.querySelector('[data-lightbox]');
      if (dialog?.showModal) {
        dialog.showModal();
        document.body.classList.add('lkz-lightbox-open');
        this.querySelector('[data-lightbox-close]')?.focus();
      }
    }

    renderLightbox() {
      const item = this.media[this.lightboxIndex];
      if (!item) return;
      this.querySelectorAll('[data-lightbox-item]').forEach((slide) => {
        const active = slide.dataset.mediaId === String(item.id);
        slide.hidden = !active;
        slide.classList.toggle('is-active', active);
        if (!active) slide.querySelectorAll('video').forEach((video) => video.pause());
      });
      const status = this.querySelector('[data-lightbox-status]');
      if (status) status.textContent = `${this.lightboxIndex + 1} of ${this.media.length}`;
    }

    moveLightbox(delta) {
      if (!this.media.length) return;
      this.lightboxIndex = (this.lightboxIndex + delta + this.media.length) % this.media.length;
      this.renderLightbox();
    }

    closeLightbox() {
      const dialog = this.querySelector('[data-lightbox]');
      if (dialog?.open) dialog.close();
      document.body.classList.remove('lkz-lightbox-open');
      this.lightboxTrigger?.focus({ preventScroll: true });
    }

    triggerBuyNow() {
      if (!this.currentVariant?.available) return;

      const fastrr = this.querySelector('.shiprocket-headless[data-type="product"]');
      const dynamicCheckout = this.querySelector('.shopify-payment-button__button:not([disabled])');
      const acceleratedButton = this.querySelector('[data-testid*="Checkout"], [name="checkout"], .shopify-payment-button__button--unbranded:not([disabled])');

      if (fastrr) {
        fastrr.click();
        return;
      }
      if (acceleratedButton) {
        acceleratedButton.click();
        return;
      }
      if (dynamicCheckout) {
        dynamicCheckout.click();
      }
    }

    updateWishlistVariant(variant) {
      if (!variant) return;
      const data = {
        productId: Number(this.querySelector('[data-wishlist-product]') ? JSON.parse(this.querySelector('[data-wishlist-product]').textContent).productId : 0),
        handle: this.querySelector('[data-icon-wishlist]')?.dataset.productHandle,
        url: this.dataset.productUrl,
        title: this.dataset.productTitle,
        featuredImage: variant.featured_image?.src || this.media.find((item) => item.type === 'image')?.src || '',
        variantId: variant.id,
        variantTitle: variant.title,
        price: variant.price,
        compareAtPrice: variant.compare_at_price,
        available: variant.available
      };
      window.dispatchEvent(new CustomEvent('lukzer:variant-changed', { detail: data }));
    }

    showToast(text, isError) {
      if (window.LukzerWishlist?.toast) {
        window.LukzerWishlist.toast(text, isError);
        return;
      }
      this.showMessage(text, isError);
    }

    async checkDelivery(event) {
      event.preventDefault();
      const input = this.querySelector('[data-pincode]');
      const result = this.querySelector('[data-delivery-result]');
      const pincode = input?.value.trim();
      if (!result) return;

      if (!/^[1-9][0-9]{5}$/.test(pincode || '')) {
        result.textContent = 'Enter a valid 6-digit Indian pincode.';
        input?.focus();
        return;
      }

      const endpoint = this.dataset.deliveryEndpoint;
      if (!endpoint) {
        result.textContent = this.dataset.deliveryFallback || 'Delivery availability will be confirmed at checkout.';
        return;
      }

      result.textContent = 'Checking delivery availability…';
      try {
        const url = new URL(endpoint, window.location.origin);
        url.searchParams.set('pincode', pincode);
        if (this.currentVariant?.id) url.searchParams.set('variant', this.currentVariant.id);
        const response = await fetch(url, { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Delivery service unavailable');
        const data = await response.json();
        const rows = [
          data.estimated_delivery && `Estimated delivery: ${data.estimated_delivery}`,
          typeof data.cod_available === 'boolean' && `COD: ${data.cod_available ? 'Available' : 'Not available'}`,
          typeof data.assembly_available === 'boolean' && `Assembly: ${data.assembly_available ? 'Available' : 'Not available'}`,
          data.delivery_charge != null && `Delivery charge: ${data.delivery_charge}`
        ].filter(Boolean);
        result.innerHTML = rows.length ? `<ul>${rows.map((row) => `<li>${this.escapeHtml(row)}</li>`).join('')}</ul>` : this.escapeHtml(this.dataset.deliveryFallback);
      } catch (error) {
        result.textContent = this.dataset.deliveryFallback || 'Delivery availability will be confirmed at checkout.';
      }
    }

    async addToCart(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      this.clearMessage();

      if (!this.currentVariant?.id || !this.currentVariant.available) {
        this.showMessage('Please select an available product option.', true);
        return;
      }

      const quantity = Math.max(1, Number(this.quantity?.value || 1));
      const assembly = this.querySelector('[data-assembly-property]')?.value || 'No';
      const assemblyVariantId = Number(this.dataset.assemblyVariantId);
      const properties = { 'Assembly Service': assembly };
      const items = [{ id: this.currentVariant.id, quantity, properties }];

      this.addButton?.classList.add('is-loading');
      if (this.addButton) this.addButton.disabled = true;

      try {
        if (assembly === 'Yes' && assemblyVariantId) {
          const cart = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`).then((response) => response.json());
          const existingService = cart.items.find((item) => item.variant_id === assemblyVariantId);
          if (existingService) {
            const updateResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: existingService.key, quantity: existingService.quantity + quantity })
            });
            const updateData = await updateResponse.json();
            if (!updateResponse.ok) throw new Error(updateData.description || 'The assembly service quantity could not be updated.');
          } else {
            items.push({
              id: assemblyVariantId,
              quantity,
              properties: { '_Assembly for': this.currentVariant.id }
            });
          }
        }

        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || 'The item could not be added to your cart.');

        document.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: { product: data, variant: this.currentVariant }
        }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        this.openThemeCart(data);
      } catch (error) {
        this.showMessage(
          assembly === 'Yes' ? `We could not add the product and assembly service: ${error.message}` : error.message,
          true
        );
      } finally {
        this.addButton?.classList.remove('is-loading');
        if (this.addButton) this.addButton.disabled = !this.currentVariant?.available;
      }
    }

    openThemeCart(data) {
      if (window.nuranium) {
        if (typeof window.nuranium.initMiniCart === 'function') window.nuranium.initMiniCart();
        if (typeof window.nuranium.PopupAddToCart === 'function') window.nuranium.PopupAddToCart();
      }

      const drawer = document.querySelector('#desktop_cart');
      const overlay = document.querySelector('.sidebar-overlay');
      const root = window.Shopify?.routes?.root || '/';
      const openDrawer = () => {
        if (drawer) drawer.classList.add('active');
        if (overlay) overlay.classList.add('act');
      };

      fetch(`${root}cart?view=json`)
        .then((response) => response.text())
        .then((html) => {
          const cartInfo = document.querySelector('#cart-info');
          if (cartInfo) cartInfo.innerHTML = html;
          return fetch(`${root}cart.js`);
        })
        .then((response) => response.json())
        .then((cart) => {
          document.querySelectorAll('.CartCount, #CartCountCavas').forEach((counter) => {
            counter.textContent = cart.item_count;
          });
        })
        .catch(() => {})
        .finally(openDrawer);

      if (!drawer && window.theme?.cart_status === 'goto_page_cart') {
        window.location.assign(`${root}cart`);
      }
    }

    attachReviewAnchor() {
      const reviewSection = document.querySelector('[data-lkz-premium-reviews], [data-lkz-review-section]');
      const reviewLink = document.querySelector('.lkz-product-nav a[href="#product-reviews"]');
      if (reviewSection?.id && reviewLink) reviewLink.href = `#${reviewSection.id}`;
    }

    scrollToReviews(event) {
      const target = document.querySelector('[data-lkz-premium-reviews], [data-lkz-review-section], #product-reviews');
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    showMessage(text, isError) {
      if (!this.message) return;
      this.message.hidden = false;
      this.message.textContent = text;
      this.message.style.color = isError ? 'var(--lkz-red)' : 'var(--lkz-muted)';
    }

    clearMessage() {
      if (!this.message) return;
      this.message.hidden = true;
      this.message.textContent = '';
    }

    escapeHtml(value) {
      const div = document.createElement('div');
      div.textContent = String(value || '');
      return div.innerHTML;
    }
  }

  if (!customElements.get('lukzer-product-detail')) {
    customElements.define('lukzer-product-detail', LukzerProductDetail);
  }
})();
